// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2VFaz","title":"AfterFrontImage_title__1OB6_"};